export const TimePeriod = {
  Day: '24h',
  Hour: '1h',
} as const

export type TimePeriod = (typeof TimePeriod)[keyof typeof TimePeriod]
